import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ModalAtom from "../../../../components/atoms/modal/modal";
import {
    applyAufmassResultRaw,
    markDirtyAfterMutation,
    selectDeleteLineDataV2,
    selectFormDataV2,
    selectShowDeleteLineModalV2,
    setAufmassError,
    setDeleteLineModal,
} from "../../../../store/slices/aufmassV2Slice";
import { selectCurrentProjectId } from "../../../../store/slices/projectDetailsSlice";
import { useDeleteAufmassLineMutation } from "../../../../store/services/aufmass";
import { showToast } from "../../../../utils/method";

function DeleteLineModalV2() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // Use V2 selectors
    const showDeleteLineModal = useSelector(selectShowDeleteLineModalV2);
    const deleteLineData = useSelector(selectDeleteLineDataV2);
    const formData = useSelector(selectFormDataV2);
    const projectId = useSelector(selectCurrentProjectId);
    const [deleteAufmassLine] = useDeleteAufmassLineMutation();

    const handleDeleteLineModalClose = useCallback(() => {
        dispatch(setDeleteLineModal({ show: false }));
    }, [dispatch]);

    const handleDeleteLineSubmit = useCallback(async () => {
        if (!deleteLineData?.line?.id) {
            showToast(t("error-invalid-line-data"), { type: "error" });
            return;
        }

        try {
            const response = await deleteAufmassLine({
                projectId,
                aufmassId: formData.id,
                groupId: deleteLineData.line.groupId,
                lineId: deleteLineData.line.id,
            }).unwrap();
            dispatch(applyAufmassResultRaw(response));
            dispatch(markDirtyAfterMutation());

            dispatch(setDeleteLineModal({ show: false }));
            showToast(t("aufmass.line-deleted-successfully"), {
                type: "success",
            });
        } catch (error) {
            dispatch(setAufmassError(error?.data?.message || error?.message));
            showToast(
                error?.data?.message || error?.message || t("aufmass.line-delete-failed"),
                { type: "error" }
            );
        }
    }, [dispatch, deleteLineData, formData.id, projectId, deleteAufmassLine, t]);

    return (
        <ModalAtom
            show={showDeleteLineModal}
            handleClose={handleDeleteLineModalClose}
            handleSubmit={handleDeleteLineSubmit}
            title={t("aufmass.confirm-delete-line")}
            body={
                <p>
                    {deleteLineData?.line?.text
                        ? t("aufmass.confirm-delete-line-message", { lineText: deleteLineData.line.text })
                        : t("aufmass.confirm-delete-line-generic")
                    }
                </p>
            }
            saveText={t("delete")}
        />
    );
}

export default DeleteLineModalV2;